import React, { Component } from 'react';
import styled from 'styled-components';
import I2XLogo from '../../components/common/icons/I2XLogo';
import { colors } from '../../utils/utils';
import useLocalization from '../../localization/useLocalization';
import { setAppPaused } from '../../utils/appPause';
import { clearStartupLoadingTimeout, markCoachLoaded } from '../../store/startup';
import { reloadPage } from '../../utils/browser';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 100px;
`;

const Button = styled.button`
    border-radius: 24px;
    border: 0;

    margin-top: 20px;

    padding: 12px 24px;

    font-size: 13px;
    font-weight: bold;

    background-color: ${colors.green.aquamarine};
    color: ${colors.white.basic};

    cursor: pointer;

    outline: none;

    & > * {
        vertical-align: middle;
    }

    & > span {
        margin-left: 6px;
    }
`;

interface LaunchScreenProps {
    localization: { getText: (key: string) => string };
}

class LaunchScreenView extends Component<LaunchScreenProps> {
    private reloadTimeout?: ReturnType<typeof setTimeout>;

    componentDidMount() {
        clearStartupLoadingTimeout();
        markCoachLoaded();

        // For check for updates
        this.reloadTimeout = setTimeout(() => {
            reloadPage();
        }, 60 * 1000); // 1 min
    }

    render() {
        return (
            <Wrapper>
                <I2XLogo color={colors.blue.i2x} />
                <Button
                    type="button"
                    onClick={() => {
                        clearTimeout(this.reloadTimeout);
                        setAppPaused(false);
                        reloadPage();
                    }}>
                    {this.props.localization.getText('trainer.launch')}
                </Button>
            </Wrapper>
        );
    }
}

function LaunchScreen() {
    const localization = useLocalization();
    return <LaunchScreenView localization={localization} />;
}

export default LaunchScreen;
